import { render, staticRenderFns } from "./RiskByLocation.vue?vue&type=template&id=35ee3997&"
import script from "./RiskByLocation.vue?vue&type=script&lang=js&"
export * from "./RiskByLocation.vue?vue&type=script&lang=js&"
import style0 from "./RiskByLocation.vue?vue&type=style&index=0&id=35ee3997&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports